import APopover from './APopover';
import { PopoverPlacement } from './PopoverBase/types';
import React from 'react';

export const withTitle = (
  body: React.ReactElement,
  title?: string,
  position?: PopoverPlacement,
  noSpan?: boolean
) => {
  if (!title?.length) return body;
  const target = noSpan ? body : <span>{body}</span>;
  return (
    <APopover
      arrow
      curveBorder
      target={target}
      placement={position || 'bottom'}
      trigger="hover"
    >
      <p
        style={{
          textWrap: 'wrap',
          maxWidth: '40vw',
          margin: '0',
        }}
      >
        {title}
      </p>
    </APopover>
  );
};

export const withMutipleTitle = (
  body: React.ReactElement, //--badge
  title?: React.ReactElement,
  position?: PopoverPlacement
) => {
  return (
    <APopover
      arrow
      curveBorder
      target={<span>{body}</span>}
      placement={position || 'bottom'}
      trigger="hover"
    >
      <div>{title}</div>
    </APopover>
  );
};
